import React, { useState } from 'react';
import useEditBonusStartBot from '../../../../../hooks/site/bonus/useEditBonusStartBot';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BotLangs from './BotLangs';
import BonusCurrency from './BonusCurrency';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import SubgroupSave from '../../../../../components/bonus/ui/SubgroupSave';
import { ENUM_BONUS_ID } from '../../../../../enums/MenuItems';

export default function StartBot({ group, groupId }) {
  const { t } = useTranslation();
  const {
    startBotEnable,
    currencies,
    curLangs,
    updateSubgroups,
    toDeposit,
    lockSetting,
    saveDisabled,
    changeLockSetting,
    changeSubgroup,
    changeEnable,
    changeDeposit,
    changeFieldValues,
    changeBonusLangs,
    onSave
  } = useEditBonusStartBot(groupId);

  return (
    <Stack display={'flex'} flexDirection={'column'} gap={1} py={1}>
      <Stack display={'flex'} flexDirection={'row'} gap={2} justifyContent={'space-between'}>
        <CusCheckbox title="Enable" checked={startBotEnable} onChange={changeEnable} />
      </Stack>
      <Typography>
        {t('Bonus for the player who launched the Telegram bot for the first time.')}
      </Typography>
      <Stack gap={2}>
        <BonusCurrency
          currencies={currencies}
          groupId={groupId}
          changeFieldValues={changeFieldValues}
        />
        <BotLangs langs={curLangs} changeBonusLangs={changeBonusLangs} />
      </Stack>
      <Stack display={'flex'} flexDirection={'row'}>
        <CusCheckbox
          label="Credit to deposit balance"
          checked={toDeposit}
          onChange={changeDeposit}
        />
      </Stack>

      <SubgroupSave
        lockSetting={lockSetting}
        updateSubgroups={updateSubgroups}
        saveDisabled={saveDisabled}
        id={ENUM_BONUS_ID.launch_bot}
        isNodeGroup={!group?.game}
        onSave={onSave}
        changeSubgroup={changeSubgroup}
        changeLockSetting={changeLockSetting}
        // showUpdate={!group?.game}
      />
    </Stack>
  );
}
